import { gql } from '@apollo/client';

export const CARD_CONTAINER_FRAGMENT = gql`
  fragment CardContainerFields on CardContainer {
    internalName
    sku
    iconImageUrl {
      iconImageUrl
    }
    mainImageUrl {
      url
      text
    }
    logoImageUrl {
      url
      text
    }
    name
    description
    explorePopupCopy
    contractDescription
    horizontalVideoUrl
    horizontalImageUrl {
      url
      text
    }
    price
    showExplorePopup
    videoUrl
    linkLabel
    linkUrl
    popupCards {
      internalName
      popupCardImageUrl {
        url
        text
      }
      popupCardSubTitle
      popupCardTitle
      popupCardDescription
      popupCardIconUrl {
        url
        text
      }
    }
  }
`;
